import { api } from "../../gateways/unilabApi";

function getPrj(payload) {
  let prj = {};
  for (const el in payload) {
    prj = payload[el];
  }

  return prj;
}
export async function getCreateProject(payload) {
  var modality = payload.modality;
  var performDesign = payload.bShowDesign;
  var performSelection = payload.bShowSelection;

  return await api.get(`project/new/${modality}/${performDesign}/${performSelection}/false`);
}

export async function postSaveProject(payload) {
  let prj = {};
  prj = getPrj(payload);

  //console.log(prj);
  return await api.post("project/save", prj);
}

export async function postUpdateProject(payload) {
  let prj = {};
  prj = getPrj(payload);

  return await api.post("project/updateProject", prj);
}

export async function postCalculate(payload) {
  let prj = {};
  prj = getPrj(payload);

  return await api.post("project/calculate", prj);
}

export async function postSaveCalculatedProject(payload) {
  let prj = {};
  prj = getPrj(payload);

  return await api.post("project/savecalculatedproject", prj);
}

export async function postProjectChart(payload) {
  return await api.post("project/projectChart", payload);
}

export async function postAvailableCharts(payload) {
  return await api.post("project/availableCharts", payload);
}

export async function getPrintProject(payload) {
  let prj = {};
  prj = getPrj(payload);

  return await api.get("ReportView/ReportViewerView", prj);
}

export async function getProjectIdNewByExistingProject(payload) {
  var modality = payload.modality;
  var projectId = payload.projectId;

  return await api.get(`project/getNewProjectIdAndSave/${modality}/${projectId}`);
}

export async function getOpenProject(payload) {
  var modality = payload.modality;
  var projectId = payload.projectId;

  return await api.get(`project/open/${modality}/${projectId}`);
}

export async function getListProjects() {
  return await api.get(`project/list/8`);
}

export async function postListProjectsById(payload) {
  return await api.get("project/listById", payload);
}

export async function impostascambiatoreselezionato(payload) {
  return await api.post("project/impostascambiatoreselezionato", payload);
}
export async function postSetDefaults(payload) {
  return await api.post("project/setDefaults", payload);
}
export async function getDefaults() {
  return await api.get("project/getDefaults");
}
